export enum ExternalCaller {
    None = 0,
    ShopIQ = 1,
}